import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { useRole } from "../../context/RoleContext";
import Navbar from "./NavBar";
import SellerNavbar from "./SellerNavbar";
import { useLocation, Navigate } from "react-router-dom";
import MobileNavbar from "./MobileNavbar";
import useWindowWidth from "../homePage/WindowWidth";
import useIsMobile from "../../common/mobileVersion/useIsMobile";
import { fetchHomepageData } from "../../api/homepage";
import { cartDataMapper } from "../../utils/cartDataMapper";
import { addItem } from "../../redux/features/slices/cartSlice";
import { getCartByCustomerId } from "../../service/cartService";

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  const { role } = useRole();
  const location = useLocation();
  const windowWidth = useWindowWidth();
  const orgId = localStorage.getItem("orgId");
  const logo = localStorage.getItem("logoURL");
  const [logoURL, setLogoURL] = useState(
    logo && logo?.length !== 0 ? logo : undefined
  );
  useEffect(() => {
    const logoURL = localStorage.getItem("logoURL");
    const setLogo = async () => {
      const response = await fetchHomepageData();
      const url = response?.brand?.smallLogoUrl;
      url && localStorage.setItem("logoURL", url);
      setLogoURL(url);
    };

    if (logoURL === null || !logoURL) setLogo();
    const fetchCartDetails = async () => {
      try {
        const cartData = await getCartByCustomerId();
        const items = cartDataMapper(cartData?.Products);
        dispatch(addItem(items));
      } catch (error: any) {
        console.log("error is fetching cart", error.message);
      }
    };
    if (role !== "seller" && !location.pathname.includes("/seller")) {
      fetchCartDetails();
    }
  }, []);

  //For MobileVersion
  const isMobile = useIsMobile();

  // Determine the Navbar based on role and path
  const getNavbarComponent = () => {
    if (role === "seller" || location.pathname.includes("/seller")) {
      return SellerNavbar;
    }
    if (role === "customer" || location.pathname.includes("/customer")) {
      return windowWidth > 599 ? Navbar : MobileNavbar;
    }

    return null; // Redirect to login if role or path mismatch
  };

  const NavbarComponent = getNavbarComponent();

  // If no NavbarComponent is found, redirect the user to the login page
  if (!NavbarComponent) {
    return <Navigate to={`/`} replace />;
  }

  //Paths to skip container Layout
  const excludedPaths = [
    `/${orgId}/customer/home`,
    `/${orgId}/seller/invoice-screen`,
  ];

  const isExcludedPath = excludedPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  const calculatePadding = (screenWidth: number) => {
    const minPadding = 64;
    const maxPadding = 216;
    const minScreen = 1024;
    const maxScreen = 1880;

    if (screenWidth <= minScreen) return minPadding;
    if (screenWidth >= maxScreen) return maxPadding;

    if (screenWidth >= 1280 && screenWidth <= 1440) {
      return 160;
    }

    if (screenWidth >= 1440 && screenWidth <= 1512) {
      return 180;
    }

    if (screenWidth >= 1512 && screenWidth <= 1728) {
      return 189;
    }

    if (screenWidth > 1728) {
      return maxPadding;
    }

    // return (
    //   minPadding +
    //   ((screenWidth - minScreen) / (maxScreen - minScreen)) *
    //     (maxPadding - minPadding)
    // );
  };

  const horizontalPadding = calculatePadding(windowWidth);
  const verticalPadding = 39;

  return (
    <div>
      <NavbarComponent logo={logoURL} />
      {/* Layout structure */}
      {!isExcludedPath ? (
        <Box sx={{ backgroundColor: "#F6F6F6", position: "relative" }}>
          <Box
            sx={{
              padding: isMobile
                ? "11px"
                : `${verticalPadding}px ${horizontalPadding}px`,
              minHeight:
                role === "seller" || location.pathname.startsWith("/seller")
                  ? "calc(100vh - 74px)"
                  : "calc(100vh - 108px)",
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            {children}
          </Box>
        </Box>
      ) : (
        <main>{children}</main>
      )}
    </div>
  );
};

export default AppLayout;
